import { render, staticRenderFns } from "./ReplyMessage.vue?vue&type=template&id=16afc4f8&scoped=true"
import script from "./ReplyMessage.vue?vue&type=script&lang=js"
export * from "./ReplyMessage.vue?vue&type=script&lang=js"
import style0 from "./ReplyMessage.vue?vue&type=style&index=0&id=16afc4f8&prod&lang=css"
import style1 from "./ReplyMessage.vue?vue&type=style&index=1&id=16afc4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afc4f8",
  null
  
)

export default component.exports